/**
 * The HOC is used to filter the specific prop with filter func and then output with the specific prop name
 * @author: Ronan
 * @param: sourceDataProp {string} prop as a source to filter
 * @param: targetDataProp {string} OPTIONAL prop name to be attached to wrapped component
 * @param: filterFunc {function} function that filter out on value
 */
import React, { Component } from 'react';

const lodashFilter = (
  sourceDataProp,
  targetDataProp = 'filteredData',
  filterFunc,
) => WrappedComponent => class extends Component {
  render() {
    const predicate = (record, i, collection) => filterFunc(record, i, collection);
    const props = {
      ...this.props,
      [targetDataProp]: _.filter(this.props[sourceDataProp], predicate),
    };
    return <WrappedComponent {...props} />;
  }
};

export default lodashFilter;



// WEBPACK FOOTER //
// ./src/components/hoc/lodashFilter.jsx